import { PopularStoriesKnownAction } from "./types";
import { AppThunkAction } from '../appThunkAction';
import hubService from '../../api/services/hub';

export const getPopularStories = (): AppThunkAction<PopularStoriesKnownAction> => async (dispatch) => {
    dispatch({
      type: "GET_POPULAR_STORY",
    });
    const data = await hubService.getPopularStories();
    dispatch({
        type: "GET_POPULAR_STORY_SUCCESS",
        payload: data.value
    })
};
